import { Suspense, type ReactNode } from 'react'
import { Card } from './Card'
import { Badge } from './Badge'
import { cn } from '../../lib/utils'

interface LiveActivityCardProps {
  title: string
  description?: ReactNode
  meta?: string
  icon?: ReactNode
  status?: 'live' | 'new' | 'read' | 'muted'
  className?: string
}

const statusTone = {
  live: 'success',
  new: 'info',
  read: 'neutral',
  muted: 'neutral',
} as const

export function LiveActivityCard({ title, description, meta, icon, status = 'live', className }: LiveActivityCardProps) {
  return (
    <Card padding="sm" interactive className={cn('live-activity-card', className)}>
      <div className="live-activity-icon">{icon || <span className="live-activity-dot" />}</div>
      <div className="live-activity-content">
        <div className="live-activity-topline">
          <div className="card-title live-activity-title">{title}</div>
          <Badge tone={statusTone[status]}>{status}</Badge>
        </div>
        {description && (
          <Suspense fallback={<div className="body live-activity-description">Loading activity...</div>}>
            <div className="body live-activity-description">{description}</div>
          </Suspense>
        )}
        {meta && <div className="caption live-activity-meta">{meta}</div>}
      </div>
    </Card>
  )
}
